export const mapsApiKey = "AIzaSyCj0ryj5kLFxMmeAGUP3X4lftkoVfmcCuU"
export const LOCALE = {
  EN: "en",
  HE: "he",
}
export const CONSTRUCTION = "construction"
